import * as React from "react";
import PropTypes from "prop-types";
const SvgSportsRockClimbingNormalSmall = React.forwardRef(
  ({ color = "currentColor", size = 24, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M2.055 3.168l-.832-.555-1.11 1.664.832.555c.297.198.494.73.246 1.388-.068.181-.13.38-.172.584l-.894 4.47A6.46 6.46 0 000 12.54v.853a5.606 5.606 0 008.715 4.665l1.517-1.012 10.601 1.631A2.749 2.749 0 0024 15.962a7.12 7.12 0 00-1.326-4.14l-.544-.76a8 8 0 00-2.299-2.152l-7.443-4.607a3 3 0 00-4.262 1.209L6.448 8.869l-.767-1.15A3.86 3.86 0 003.27 6.084c.13-1.045-.17-2.22-1.214-2.916zm.758 4.864a1.86 1.86 0 011.204.797l4.596 6.894-1.007.671a3.606 3.606 0 01-5.606-3v-.853c0-.294.029-.587.087-.875zm18.324 8.67l-10.55-1.623-1.24-1.86 12.59 1.937c.041.265.063.535.063.806 0 .459-.41.81-.863.74zM7.725 10.785l2.19-4.379a1 1 0 011.42-.403l.798.494-1.275 2.55 1.789.895 1.194-2.388.965.597-1.148 2.296 1.789.895 1.067-2.134 2.265 1.403a6.001 6.001 0 011.724 1.614l.543.76.008.012-13.21-2.033z"
        fill=""
      />
    </svg>
  )
);
SvgSportsRockClimbingNormalSmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgSportsRockClimbingNormalSmall;
